import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { Subscription } from 'rxjs';

import { FeedbackExecutionService } from 'src/app/core/services/feedback-execution.service';
import { MeetingService } from 'src/app/core/services/meeting.service';
import { AngularModalService } from 'src/app/core/services/modal.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { UserRoleService } from 'src/app/core/services/user-role.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { CandidateService } from 'src/app/core/services/candidate.service';
import { DateTimeUtilityService } from 'src/app/core/services/date-time-utility.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { SharedService } from 'src/app/core/services/shared.service';
import { OutreachService } from 'src/app/core/services/outreach.service';
import { JobService } from 'src/app/core/services/job.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';
import { CandidateAdditionalDetails } from 'src/app/core/models/candidateAdditionalDetails';
import { ScreeningExecutionResult } from 'src/app/public/app/models/screeningExecutionResult';
import { FeedbackExecutionActionsModalComponent } from './feedback-execution-actions-modal/feedback-execution-actions-modal.component';
import * as _ from 'lodash';

declare var $: any;
declare var moment: any;

@Component({
    selector: 'app-feedback-execution',
    templateUrl: './feedback-execution.component.html',
    styleUrls: ['./feedback-execution.component.css']
})
export class FeedbackExecutionComponent implements OnInit, OnChanges {

    // '@' bindings
    @Input() jobMatchId: string;
    @Input() candidateId: string;
    @Input() feedbackUserIdsList: string;
    @Input() feedbackType: string;
    @Input() parentScheduleId: string;
    @Input() childScheduleId: string;
    @Input() context: string;
    @Input() activeOutreachFeedbackQuestionsList: string;
    @Input() outreachData: string;
    @Input() sourceScreen: string;

    // '<' one-way bindings
    @Input() loginRequired: boolean;
    @Input() externalCommentRequired: boolean;
    @Input() usersToEditFeedback: any;
    @Input() feedbackReadOnly: boolean;
    @Input() disableFeedbackQuestions: boolean;
    @Input() isFeedbackTabActive: boolean;

    // '=' two-way bindings
    @Input() externalMeetingCallId: any;
    @Output() externalMeetingCallIdChange = new EventEmitter<any>();
    @Input() formalizeActivityPayload: any;
    @Output() formalizeActivityPayloadChange = new EventEmitter<any>();

    // '&' callback bindings
    @Output() saveCallback = new EventEmitter<any>();
    @Output() completeFeedbackCallback = new EventEmitter<any>();
    @Output() candidateContactDetailsMissingCallback = new EventEmitter<any>();

    // state fields (ported from legacy $onInit)
    totalClQnsCount = 0;
    totalCount = 0;
    recruiterqns: any = null;
    companyQnsComplete: any;
    type: any;
    externalNotesAction: any = {};
    companyId: any = null;
    feedbackQuestionsCompanyId: any = null;
    loggedInUserId: any = null;
    showMeetingLink = false;
    isCorporateFlag = false;
    showInterested = true;
    savingFlag = false;
    completingFlag = false;
    saveComplete = false;
    displayQuestions = false;
    userList: any[] = [];
    savedRecruiterQns: any;
    userGetRecruiterQns: any;
    jobMatch: any;
    candidateJobMatch: any = {};
    displayRecruiterName = false;
    feedbackTypeLabel = '';
    noEditableMeetingsLabel = '';
    completeButtonLabel = '';
    userId: any = null;
    chosenUser: any = null;
    chosenMeeting: any = null;
    screeningFeedbackStartedData: any = null;
    previousEnableEditFor: any = null;

    // flags
    loadingJobMatchDetailsFlag = false;
    loadingFeedbackOptionsFlag = false;
    loadingFeedbackDetailsFlag = false;
    showAdditionalCandidateDetailsFlag = false;
    showMeetingsFlag = false;
    editableMeetingsExistFlag = false;
    clientOrBuExists = true;
    userHasAccessToFeedback = false;
    showAllCompanyQuestionComments = true;
    showAllClientQuestionComments = true;
    loadingUsers = true;
    showChosenUserDetails = true;
    isCompanyQuestionExists = false;

    formalizeItemsArray: any[] = [];
    feedbackExecutionResult: any;
    meetingsList: any[] = [];
    isCandidateContactDetailsMissing = false;
    isCandidateContactAdditionalDetailsMissing = false;
    candidateAdditionalDetails: any;
    savedCandidateAdditionalDetails: any;
    jobTypeList: any;
    salaryDurationOptions: any;
    enableEditForAttendeeId: any;
    previouslyEnabledEditForAttendeeId: any;
    enabledEditForUser: any;
    selectedComments: any;
    selectedCommentsMap: any;
    formalizeMode: any;
    formalizeItems: any;
    copyNote: any;
    clientNotInterestedList: any[] = [];
    jobNotInterestedList: any[] = [];
    isCorporateAccessingVendorCandidate: boolean;
    requisitionSponsorships: any;

    private meetingEventSubscriptions = new Subscription();

    constructor(
        private feedbackExecutionService: FeedbackExecutionService,
        private meetingService: MeetingService,
        private modalService: AngularModalService,
        private companyService: CompanyService,
        private userRoleService: UserRoleService,
        private jobMatchService: JobMatchService,
        private candidateService: CandidateService,
        private dateTimeUtilityService: DateTimeUtilityService,
        private alertsAndNotificationsService: AlertAndNotificationsService,
        private sharedService: SharedService,
        private outreachService: OutreachService,
        private jobService: JobService,
        private authService: AuthService,
        private bsModalService: BsModalService
    ) { }

    ngOnInit(): void {
        // initialize variables
        this.totalClQnsCount = 0;
        this.totalCount = 0;
        this.recruiterqns = null;
        this.companyId = null;
        this.feedbackQuestionsCompanyId = null;
        this.loggedInUserId = null;
        this.showMeetingLink = false;
        this.isCorporateFlag = false;
        this.showInterested = true;
        this.savingFlag = false;
        this.completingFlag = false;
        this.saveComplete = false;
        this.displayQuestions = false;
        this.userList = [];
        this.candidateJobMatch = {};
        this.displayRecruiterName = false;
        this.feedbackTypeLabel = '';
        this.noEditableMeetingsLabel = '';
        this.completeButtonLabel = '';
        this.userId = null;
        this.chosenUser = null;
        this.chosenMeeting = null;
        this.screeningFeedbackStartedData = null;
        this.previousEnableEditFor = null;
        // flags
        this.loadingJobMatchDetailsFlag = false;
        this.loadingFeedbackOptionsFlag = false;
        this.loadingFeedbackDetailsFlag = false;
        this.showAdditionalCandidateDetailsFlag = false;
        this.showMeetingsFlag = false;
        this.editableMeetingsExistFlag = false;
        this.clientOrBuExists = true;
        this.userHasAccessToFeedback = false;
        this.showAllCompanyQuestionComments = true;
        this.showAllClientQuestionComments = true;
        this.loadingUsers = true;
        this.showChosenUserDetails = true;
        this.isCompanyQuestionExists = false;

        this.getAllPreferredJobTypes();
        this.getSalaryDurationOptions();
        this.init(false);
        if (this.externalMeetingCallId) {
            this._setMeetingListeners();
        }

        this._checkAndSaveFeedbackIfMeetingEnd();

        // Formalize comments (Users only)
        this.formalizeItemsArray = this._getAllItemsArray();
    }

    ngOnChanges(changes: SimpleChanges): void {
        const hasUsersListChanged = this._isNotInit(changes) && changes.usersToEditFeedback !== undefined && this._hasFeedbackUsersChanged(changes);
        if (hasUsersListChanged) {
            this.setFeedbackEnabledAttendeeId();
        }

        if (changes.activeOutreachFeedbackQuestionsList) {
            this.setOutreachQuestionsForFeedback(changes.activeOutreachFeedbackQuestionsList.currentValue);
        }

        if (changes.outreachData && !changes.outreachData.isFirstChange() && changes.outreachData.currentValue) {
            this.setOutreachFeedbackData(changes.outreachData.currentValue);
        }
    }

    ngOnDestroy(): void {
        this.meetingEventSubscriptions.unsubscribe();
    }

    _hasFeedbackUsersChanged(changes: SimpleChanges): boolean {
        if (_.isEmpty(changes.usersToEditFeedback.previousValue)) {
            return true;
        }
        if (!Array.isArray(changes.usersToEditFeedback.previousValue) || !Array.isArray(changes.usersToEditFeedback.currentValue)) {
            return true;
        }
        const previousAttendees = changes.usersToEditFeedback.previousValue.map(attendee => attendee.attendeeId).sort();
        const currentAttendees = changes.usersToEditFeedback.currentValue.map(attendee => attendee.attendeeId).sort();
        return !_.isEqual(previousAttendees, currentAttendees);
    }

    _isNotInit(changes: SimpleChanges): boolean {
        return changes.externalMeetingCallId == undefined;
    }

    init(refreshFlag) {
        if (this.loginRequired == undefined) {
            this.loginRequired = true;
        }
        if (this.parentScheduleId == undefined) {
            this.parentScheduleId = null;
        }
        if (this.childScheduleId == undefined) {
            this.childScheduleId = null;
        }
        if (this.externalCommentRequired == undefined) {
            this.externalCommentRequired = false;
        }
        if (this.usersToEditFeedback == undefined) {
            this.usersToEditFeedback = [];
        }
        if (this.feedbackReadOnly == undefined) {
            this.feedbackReadOnly = false;
        }
        if (this.context == 'conference' && this.externalMeetingCallId) {
            this.setFeedbackEnabledAttendeeId();
        }
        this.meetingsList = [];
        this.loggedInUserId = this.authService.getUserDetails().id;
        this.companyId = this.authService.getUserDetails().company.companyId;
        this.isCorporateFlag = (this.authService.getUserDetails().company.companyType === MESSAGECONSTANTS.COMPANY_TYPES.CORPORATE);
        this.feedbackExecutionResult = new ScreeningExecutionResult();
        this._setLabels();
        if (!_.isUndefined(refreshFlag) && refreshFlag) {
            this.loadingFeedbackOptionsFlag = true;
            this.loadingFeedbackDetailsFlag = true;
        } else {
            this.loadingJobMatchDetailsFlag = true;
        }
        this.isCandidateContactDetailsMissing = false;
        this.isCandidateContactAdditionalDetailsMissing = false;
        if (this.context === 'outreach') {
            this.getOutreachFeedbackQuestions();
        } else {
            this.getCandidateJobMatchCardInfo(refreshFlag, () => {
                this.loadingJobMatchDetailsFlag = false;
                if (this.feedbackType == 'Screening') {
                    this.loadingFeedbackOptionsFlag = true;
                    this.getUserList(() => {
                        this.loadingFeedbackOptionsFlag = false;
                        this.showChosenUserDetails = true;
                        if (this._isCorporateAccessingVendorCandidateFeedback()) {
                            this.chosenUser = this.userList[0];
                            this.feedbackEntityChanged();
                            this.showChosenUserDetails = false;
                        } else if (!_.isUndefined(this.feedbackUserIdsList) && this.feedbackUserIdsList.length > 0) {
                            if (_.isUndefined(refreshFlag) || !refreshFlag) {
                                if (typeof this.feedbackUserIdsList === 'string') {
                                    this.feedbackUserIdsList = JSON.parse(this.feedbackUserIdsList);
                                }
                            }
                            let passedInUser: any = {};
                            this.userList.forEach((val, key) => {
                                (this.feedbackUserIdsList as any).forEach((passedInUserId, key2) => {
                                    if (val.id == passedInUserId) {
                                        passedInUser = val;
                                        this.userId = val.id;
                                    }
                                });
                            });
                            this.userList = [];
                            this.userList.push(passedInUser);
                            this.chosenUser = passedInUser;
                            this.feedbackEntityChanged();
                        } else if (this.userList.length == 1) {
                            this.chosenUser = this.userList[0];
                            this.feedbackEntityChanged();
                        } else {
                            if (!_.isUndefined(refreshFlag) && refreshFlag) {
                                setTimeout(() => {
                                    $('#chosenUser-' + this.chosenUser.id).prop('checked', true);
                                }, 500);
                                this.feedbackEntityChanged();
                            }
                        }
                        this.checkRecruiterScreeningStatus();
                    }, () => {
                        this.loadingFeedbackOptionsFlag = false;
                    });
                } else if (this.feedbackType == 'Interview') {
                    this.showMeetingsFlag = false;
                    this.loadingFeedbackOptionsFlag = true;
                    let loggedInUserId = null;
                    if (!this.loginRequired) {
                        loggedInUserId = this.loggedInUserId;
                    }
                    this.jobMatchService.getInterviewers(this.jobMatchId, this.companyId, loggedInUserId, false, (data) => {
                        this._massageMeetingDetails(data, refreshFlag);
                    }, (error) => {
                        this.loadingFeedbackOptionsFlag = false;
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    });
                } else if (this.feedbackType == 'PhoneScreen') {
                    this.showMeetingsFlag = false;
                    this.loadingFeedbackOptionsFlag = true;
                    let loggedInUserId = null;
                    if (!this.loginRequired) {
                        loggedInUserId = this.loggedInUserId;
                    }
                    this.jobMatchService.getPhoneScreeners(this.jobMatchId, this.companyId, loggedInUserId, false, (data) => {
                        this._massageMeetingDetails(data, refreshFlag);
                    }, (error) => {
                        this.loadingFeedbackOptionsFlag = false;
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    });
                } else if (this.feedbackType == 'RecruiterScreening') {
                    this.showMeetingsFlag = false;
                    this.loadingFeedbackOptionsFlag = true;
                    let loggedInUserId = null;
                    if (!this.loginRequired) {
                        loggedInUserId = this.loggedInUserId;
                    }
                    this.jobMatchService.getRecruiterScreeners(this.jobMatchId, this.companyId, loggedInUserId, false, (data) => {
                        this._massageMeetingDetails(data, refreshFlag);
                    }, (error) => {
                        this.loadingFeedbackOptionsFlag = false;
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    });
                }
            });
        }
    }

    _onCommentChange() {
        try {
            this.formalizeItemsArray = this._getAllItemsArray();
        } catch (e) {
            console.error('Failed to build formalize items on comment change', e);
            this.formalizeItemsArray = [];
        }
    }

    _getAllItemsArray() {
        const out = [];
        if (!this.recruiterqns) { return out; }

        try {
            const coKey = this.feedbackQuestionsCompanyId;
            const companyQuestions = this.recruiterqns.companyQuestionsResults && this.recruiterqns.companyQuestionsResults[coKey] ? this.recruiterqns.companyQuestionsResults[coKey] : [];
            companyQuestions.forEach(q => {
                const text = (q.recruiterComment || q.recruiterNote || '').trim();
                if (text && String(text).trim().length > 0) {
                    const id = q.id != null ? String(q.id) : Math.random().toString(36).slice(2, 8);
                    out.push({ key: `company-${id}`, label: q.question || 'Company Comment', text, companyName: this.recruiterqns.companyName || null });
                }
            });
        } catch (e) {
            console.error('Failed to process recruiter feedback questions', e);
        }

        try {
            const clientResults = this.recruiterqns.clientQuestionsResults || {};
            Object.keys(clientResults).forEach(clientKey => {
                const arr = clientResults[clientKey] || [];
                arr.forEach(q => {
                    const text = (q.recruiterComment || q.recruiterNote || '').trim();
                    if (text && String(text).trim().length > 0) {
                        const id = q.id != null ? String(q.id) : Math.random().toString(36).slice(2, 8);
                        out.push({ key: `client-${clientKey}-${id}`, label: q.question || 'Client Comment', text, companyName: this.recruiterqns.clientDetails ? this.recruiterqns.clientDetails[clientKey] : null });
                    }
                });
            });
        } catch (e) {
            console.error('Failed to process recruiter feedback questions', e);
        }

        try {
            const jobResults = this.recruiterqns.jobQuestionsResults || {};
            Object.keys(jobResults).forEach(jobKey => {
                const arr = jobResults[jobKey] || [];
                arr.forEach(q => {
                    const text = (q.recruiterComment || q.recruiterNote || '').trim();
                    if (text && String(text).trim().length > 0) {
                        const id = q.id != null ? String(q.id) : Math.random().toString(36).slice(2, 8);
                        out.push({ key: `job-${jobKey}-${id}`, label: q.question || 'Job Comment', text, companyName: this.recruiterqns.companyName || null });
                    }
                });
            });
        } catch (e) {
            console.error('Failed to process recruiter feedback questions', e);
        }

        return out;
    }

    handleBulkSave(updatedItems) {
        const items = (updatedItems && updatedItems.entity && updatedItems.entity.items) ? updatedItems.entity.items : updatedItems;
        if (!items || !Array.isArray(items)) { return; }

        items.forEach(u => {
            const key = u.key || '';
            try {
                if (key.indexOf('company-') === 0) {
                    const id = key.substring('company-'.length);
                    Object.keys(this.recruiterqns.companyQuestionsResults || {}).forEach(k => {
                        const arr = this.recruiterqns.companyQuestionsResults[k];
                        if (Array.isArray(arr)) {
                            arr.forEach(q => { if (String(q.id) == String(id)) { q.recruiterComment = u.text; } });
                        }
                    });
                } else if (key.indexOf('client-') === 0) {
                    const parts = key.split('-');
                    const clientKey = parts[1];
                    const id = parts.slice(2).join('-');
                    const arr = (this.recruiterqns.clientQuestionsResults && this.recruiterqns.clientQuestionsResults[clientKey]) || [];
                    arr.forEach(q => { if (String(q.id) == String(id)) { q.recruiterComment = u.text; } });
                } else if (key.indexOf('job-') === 0) {
                    const parts = key.split('-');
                    const jobMatchId = parts[1];
                    const id = parts.slice(2).join('-');
                    const arr = (this.recruiterqns.jobQuestionsResults && this.recruiterqns.jobQuestionsResults[jobMatchId]) || [];
                    arr.forEach(q => { if (String(q.id) == String(id)) { q.recruiterComment = u.text; } });
                }
            } catch (e) {
                console.error('Failed to map formalized text back to recruiter feedback', e);
            }
        });

        this.formalizeMode = false;
        this.formalizeItems = null;
        this.selectedComments = {};
        this.selectedCommentsMap = {};
    }

    onToggleSelect(key, obj, prop, label) {
        if (!this.selectedComments) { this.selectedComments = {}; }
        if (!this.selectedCommentsMap) { this.selectedCommentsMap = {}; }
        if (this.selectedComments[key]) {
            this.selectedCommentsMap[key] = { obj, prop, label: label || key };
        } else {
            delete this.selectedCommentsMap[key];
        }
    }

    hasSelectedComments() {
        return this.selectedCommentsMap && Object.keys(this.selectedCommentsMap).length > 0;
    }

    _getSelectedItemsArray() {
        const out = [];
        if (!this.selectedCommentsMap) { return out; }
        Object.keys(this.selectedCommentsMap).forEach(k => {
            const m = this.selectedCommentsMap[k];
            let companyOrClient = null;
            if (k && k.indexOf('client-') === 0) {
                const parts = k.split('-');
                const clientKey = parts.length >= 2 ? parts[1] : null;
                if (clientKey && this.recruiterqns && this.recruiterqns.clientDetails) {
                    companyOrClient = this.recruiterqns.clientDetails[clientKey] || null;
                }
            }
            if (!companyOrClient && k && (k.indexOf('company-') === 0 || k.indexOf('overall-') === 0)) {
                companyOrClient = this.recruiterqns && this.recruiterqns.companyName ? this.recruiterqns.companyName : null;
            }
            if (!companyOrClient && m.obj) {
                companyOrClient = m.obj.companyName || m.obj.clientOrBUName || m.obj.clientName || m.obj.company || m.obj.client || m.obj.CompanyName || null;
            }
            const textVal = (m.obj && m.obj[m.prop]) ? m.obj[m.prop] : '';
            if (textVal && String(textVal).trim().length > 0) {
                out.push({ key: k, label: m.label, text: textVal, companyName: companyOrClient });
            }
        });
        return out;
    }

    _isCorporateAccessingVendorCandidateFeedback() {
        return this.companyService.isCorporateCompany() && !this._isUserOfSameCompany(this.userList[0].id);
    }

    setFeedbackEnabledAttendeeId() {
        this.loadingUsers = true;
        this.meetingService.getFeedbackEditEnabledAttendeeId(this.externalMeetingCallId, data => {
            this.enableEditForAttendeeId = data.attendeeId;
            this.previouslyEnabledEditForAttendeeId = data.attendeeId;
            this._setUserToEditFeedback();
        }, error => {
            this.loadingUsers = false;
        });
    }

    _setMeetingListeners() {
        this.meetingEventSubscriptions.add(this.meetingService.participantFeedbackEditRequest.subscribe(message => {
            this.openEditFeedbackApprovalModal(message);
        }));

        this.meetingEventSubscriptions.add(this.meetingService.participantFeedbackEditReject.subscribe(() => {
            this.alertsAndNotificationsService.showAlert('Edit Request Denied', 'Your request to edit the feedback has been denied. Please try again later.', 'warning');
        }));

        this.meetingEventSubscriptions.add(this.meetingService.refreshFeedbackTab.subscribe(() => {
            this.init(true);
        }));
    }

    _setUserToEditFeedback() {
        this.loadingUsers = true;
        if (Array.isArray(this.usersToEditFeedback) && this.usersToEditFeedback.length > 0) {
            this.enabledEditForUser = this.usersToEditFeedback.find(user => user.attendeeId == this.enableEditForAttendeeId);
            if (this.enabledEditForUser !== undefined) {
                this.feedbackReadOnly = this.enabledEditForUser.displayName !== 'You';
                this.previousEnableEditFor = _.cloneDeep(this.enabledEditForUser);
            }
        }
        setTimeout(() => {
            this.loadingUsers = false;
        }, 2000);
    }

    _setLabels() {
        if (_.isNull(this.feedbackType) || _.isUndefined(this.feedbackType)) {
            this.feedbackType = 'Screening';
            this.feedbackTypeLabel = 'Screening Feedback for';
            this.getCandidateProfile(() => {
                this.showAdditionalCandidateDetailsFlag = true;
            });
        } else {
            if (this.feedbackType == 'Interview') {
                this.feedbackTypeLabel = 'Interview Feedback for';
                this.noEditableMeetingsLabel = "No 'Interviews' available for Feedback !";
            } else if (this.feedbackType == 'PhoneScreen') {
                this.feedbackTypeLabel = 'Phone Screen Feedback for';
                this.noEditableMeetingsLabel = "No 'Phone Screens' available for Feedback !";
            } else if (this.feedbackType == 'RecruiterScreening') {
                this.feedbackTypeLabel = 'Recruiter Screening Feedback for';
                this.noEditableMeetingsLabel = "No 'Recruiter Screenings' available for Feedback !";
            } else if (this.feedbackType == 'Outreach') {
                this.feedbackTypeLabel = 'Outreach Feedback for';
            } else {
                this.feedbackTypeLabel = 'Screening Feedback for';
                this.getCandidateProfile(() => {
                    this.showAdditionalCandidateDetailsFlag = true;
                });
            }
        }
    }

    _massageMeetingDetails(data, refreshFlag) {
        this._setMeetingsList(data);
        if (!_.isUndefined(this.feedbackUserIdsList) && this.feedbackUserIdsList.length > 0) {
            if (_.isUndefined(refreshFlag) || !refreshFlag) {
                if (typeof this.feedbackUserIdsList === 'string') {
                    this.feedbackUserIdsList = JSON.parse(this.feedbackUserIdsList);
                }
            }
            const meetings = _.filter(this.meetingsList, (meeting) => {
                return meeting.meetingScheduleId == this.parentScheduleId;
            });
            this.meetingsList = _.cloneDeep(meetings);
            this.chosenMeeting = this.meetingsList[0];
            this.loadingFeedbackOptionsFlag = false;
            this.feedbackEntityChanged();
        } else if (this.meetingsList.length == 1) {
            this.loadingFeedbackOptionsFlag = false;
            this.chosenMeeting = this.meetingsList[0];
            this.feedbackEntityChanged();
        } else {
            this.loadingFeedbackOptionsFlag = false;
        }
        this.showMeetingsFlag = true;
        if (this.meetingsList.length > 1 && !_.isUndefined(refreshFlag) && refreshFlag) {
            setTimeout(() => {
                $('#chosenMeeting-' + this.chosenMeeting.id).prop('checked', true);
            }, 500);
            this.feedbackEntityChanged();
        }
    }

    getCandidateProfile(successCallback) {
        this.candidateService.getCandidateProfile(this.candidateId, false, (data) => {
            this.candidateAdditionalDetails = data.candidateAdditionalDetails;
            if (_.isNull(this.candidateAdditionalDetails)) {
                this.candidateAdditionalDetails = new CandidateAdditionalDetails();
            }
            this.candidateAdditionalDetails.candidateId = this.candidateId;
            this.savedCandidateAdditionalDetails = _.cloneDeep(this.candidateAdditionalDetails);
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    checkRecruiterScreeningStatus() {
        this.screeningFeedbackStartedData = null;
        const userIdToCheckScreeningStatus = _.isNull(this.userId) ? this.loggedInUserId : this.userId;
        this.feedbackExecutionService.checkRecruiterScreeningStatus(this.jobMatchId, userIdToCheckScreeningStatus, this.companyId, (data) => {
            if (data.status == 'STARTED') {
                this.screeningFeedbackStartedData = data;
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    feedbackEntityChanged() {
        this.totalClQnsCount = 0;
        this.totalCount = 0;
        this.showMeetingLink = false;
        if (this.feedbackType == 'Screening') {
            if (_.isNull(this.chosenUser) || _.isUndefined(this.chosenUser)) {
                return;
            }
            this.userGetRecruiterQns = this.chosenUser.id;
            this._setUserAccessToFeedback(this.chosenUser.employer ? this.chosenUser.employer.id : null);
            if (this.candidateJobMatch.jobMatchCurrentState == 'Activated') {
                this.completeButtonLabel = 'Update';
            } else {
                this.completeButtonLabel = 'Complete';
            }
        } else {
            if (_.isNull(this.chosenMeeting) || _.isUndefined(this.chosenMeeting)) {
                return;
            }
            this.userGetRecruiterQns = this.chosenMeeting.userList[0].userId;
            this._setUserAccessToFeedback(this.chosenMeeting.userList[0].companyId);
            if (this.chosenMeeting.status == 'COMPLETED') {
                this.completeButtonLabel = 'Update';
                this.showMeetingLink = false;
            } else {
                this.completeButtonLabel = 'Complete';
                if (this.chosenMeeting.meetingMode !== null && this.context !== 'conference') {
                    this.showMeetingLink = true;
                    let workflowStep = 'ps';
                    if (this.feedbackType == 'Interview') {
                        workflowStep = 'in';
                    } else if (this.feedbackType == 'RecruiterScreening') {
                        workflowStep = 'rs';
                    }
                    this.chosenMeeting.meetingUrl = this.meetingService.getMeetingUrl(this.chosenMeeting.id, workflowStep, this.chosenMeeting.meetingMode);
                } else {
                    this.showMeetingLink = false;
                }
            }
        }
        this.getRecruiterQuestions();
    }

    _setUserAccessToFeedback(participantCompanyId) {
        if (!this.loginRequired) {
            this.userHasAccessToFeedback = true;
        } else {
            this.userHasAccessToFeedback = this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin() || this._isUserOfSameCompany(participantCompanyId) || this.feedbackType !== 'Screening';
        }
    }

    _isUserOfSameCompany(participantCompanyId) {
        return this.candidateJobMatch.jobMatchCompanyId == null || participantCompanyId == this.candidateJobMatch.jobMatchCompanyId;
    }

    getCandidateJobMatchCardInfo(refreshFlag, successCallback) {
        if (!_.isUndefined(refreshFlag) && refreshFlag) {
            if (successCallback) {
                successCallback();
            }
        } else {
            let loggedInUserId;
            if (!this.loginRequired) {
                loggedInUserId = this.loggedInUserId;
            }
            this.jobMatchService.getCandidateJobMatchCard(this.jobMatchId, this.companyId, (data) => {
                data.name = data.firstName + ' ' + data.lastName;
                _.merge(this.candidateJobMatch, data);
                this._checkIfContactDetailsMissing();
                if (successCallback) {
                    successCallback();
                }
            }, (error) => {
                if (this.authService.isOnline) {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
            }, loggedInUserId);
        }
    }

    getUserList(successCallback, errorCallback) {
        this.feedbackExecutionService.getUserList(this.jobMatchId, this.companyId, (data) => {
            this.userList = _.cloneDeep(data);
            this.displayRecruiterName = true;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            if (this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            if (errorCallback) {
                errorCallback();
            }
        });
    }

    _setMeetingsList(response) {
        this.meetingsList = [];
        let workflowStep = 'ps';
        if (this.feedbackType == 'Interview') {
            workflowStep = 'in';
        } else if (this.feedbackType == 'RecruiterScreening') {
            workflowStep = 'rs';
        }
        (response as any[]).forEach((meetingDetails, key) => {
            const meeting: any = {};
            meeting.id = meetingDetails.meetingScheduleId;
            meeting.status = meetingDetails.status;
            meeting.meetingScheduleId = meetingDetails.meetingScheduleId;
            meeting.meetingMode = meetingDetails.meetingMode;
            meeting.meetingUrl = this.meetingService.getMeetingUrl(meeting.id, workflowStep, meeting.meetingMode);
            const startDateTime = new Date(meetingDetails.meetingStartTime);
            const endDateTime = new Date(meetingDetails.meetingEndTime);
            switch (meeting.status) {
                case 'SCHEDULED':
                case 'ACTIVE':
                    meeting.statusClass = 'fa fa-calendar feedback-meeting-icon-scheduled';
                    meeting.statusLabel = 'Scheduled';
                    meeting.editableFlag = true;
                    this.editableMeetingsExistFlag = true;
                    break;
                case 'IN_PROGRESS':
                    meeting.statusClass = 'fa fa-hourglass-half feedback-meeting-icon-in-progress';
                    meeting.statusLabel = 'In Progress';
                    meeting.editableFlag = true;
                    this.editableMeetingsExistFlag = true;
                    break;
                case 'COMPLETED':
                    meeting.statusClass = 'fa fa-check feedback-meeting-icon-completed';
                    meeting.statusLabel = 'Completed';
                    meeting.editableFlag = true;
                    this.editableMeetingsExistFlag = true;
                    break;
                case 'OVERDUE':
                    meeting.statusClass = 'fas fa-clock feedback-meeting-icon-overdue';
                    meeting.statusLabel = 'Overdue';
                    meeting.editableFlag = true;
                    this.editableMeetingsExistFlag = true;
                    break;
                case 'CANCELLED':
                    meeting.statusClass = 'fa fa-ban feedback-meeting-icon-cancelled';
                    meeting.statusLabel = 'Canceled';
                    meeting.editableFlag = false;
                    break;
                default:
                    meeting.statusClass = 'fa fa-question feedback-meeting-icon-in-progress';
                    meeting.statusLabel = 'Status Unknown';
                    meeting.editableFlag = false;
            }

            switch (meeting.meetingMode) {
                case 'VIDEO':
                    meeting.meetingModeClass = 'fas fa-video';
                    break;
                case 'AUDIO':
                    meeting.meetingModeClass = 'fas fa-microphone';
                    break;
                case 'PHONE':
                    meeting.meetingModeClass = 'fas fa-phone';
                    break;
                case 'FACE_TO_FACE':
                    meeting.meetingModeClass = 'fas fa-user-friends';
                    break;
                default:
                    meeting.meetingModeClass = 'd-none';
                    break;
            }
            meeting.scheduledTime = moment(startDateTime).format('MMM DD, YYYY ( hh:mm a') + ' to ' + moment(endDateTime).format('hh:mm a )');
            meeting.userList = [];
            meeting.userNamesLabel = '';
            meetingDetails.participants.forEach((meetingUser, k) => {
                const user: any = {};
                user.userId = meetingUser.id;
                user.userName = meetingUser.firstName;
                if (!_.isUndefined(meetingUser.lastName) && !_.isNull(meetingUser.lastName)) {
                    user.userName += ' ' + meetingUser.lastName;
                }
                user.isPoc = meetingUser.isPoc;
                user.companyId = meetingUser.company.id;
                meeting.userList.push(user);
                if (this.candidateJobMatch.isSharedRequisition && !this.isCorporateFlag) {
                    if (user.isPoc) {
                        meeting.userNamesLabel = (meeting.userNamesLabel == '' ? user.userName : meeting.userNamesLabel + ', ' + user.userName);
                    }
                } else {
                    meeting.userNamesLabel = (meeting.userNamesLabel == '' ? user.userName : meeting.userNamesLabel + ', ' + user.userName);
                }
            });
            this.meetingsList.push(meeting);
        });
    }

    getRecruiterQuestions(successCallback?: () => void) {
        this.loadingFeedbackDetailsFlag = true;
        const meetingScheduleId = this.feedbackType == 'Screening' ? null : this.chosenMeeting.meetingScheduleId;
        const loggedInUserId = this.loggedInUserId;
        this.feedbackExecutionService.getRecruiterQuestions(this.jobMatchId, this.userGetRecruiterQns, this.companyId, meetingScheduleId, loggedInUserId, (data) => {
            this.loadingFeedbackDetailsFlag = false;
            this.recruiterqns = _.cloneDeep(data);
            this.recruiterqns.readOnly = true;
            if (this.context !== 'conference') {
                this.feedbackReadOnly = this.recruiterqns.readOnly;
            }
            this.candidateId = data.candidate.id;
            this.feedbackQuestionsCompanyId = null;
            Object.keys(this.recruiterqns.companyQuestionsResults).forEach((key) => {
                this.feedbackQuestionsCompanyId = key;
            });

            Object.keys(this.recruiterqns.jobDetails).forEach((key) => {
                const job = this.recruiterqns.jobDetails[key];
                if (!_.isNull(job.assignedRecruiterName)) {
                    const index = job.recruiterNames.findIndex((name) => {
                        return name == job.assignedRecruiterName;
                    });
                    if (index !== -1) {
                        job.recruiterNames.splice(index, 1);
                    }
                }
                if (this.feedbackType == 'Screening' && !job.feedbackSavedBefore) {
                    job.interested = null;
                }
            });
            this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId].forEach((val, key) => {
                if (_.isNull(val.id)) {
                    val.id = Math.floor((Math.random() * 100) + 1).toString();
                    val.randomIdCreatedFlag = true;
                    val.showComment = true;
                }
            });
            Object.keys(this.recruiterqns.clientQuestionsResults).forEach((clientKey) => {
                const clientVal = this.recruiterqns.clientQuestionsResults[clientKey];
                clientVal.forEach((val, key) => {
                    if (_.isNull(val.id)) {
                        val.id = Math.floor((Math.random() * 100) + 1).toString();
                        val.randomIdCreatedFlag = true;
                        val.showComment = true;
                    }
                });
            });
            if (this.recruiterqns.sortedClientList.length == 0) {
                this.clientOrBuExists = false;
            }
            this.displayQuestions = true;
            for (const key in this.recruiterqns.jobDetails) {
                if (this.recruiterqns.jobDetails.hasOwnProperty(key)) {
                    const jobDetailval = this.recruiterqns.jobDetails[key];
                    this.type = jobDetailval.feedbackType;
                    break;
                }
            }
            if (this.type != 'R') {
                this.showInterested = false;
            }
            this.savedRecruiterQns = _.cloneDeep(this.recruiterqns);
            this.checkifCompanyCompleted();
            this.initializeSliders();
            try {
                this.formalizeItemsArray = this._getAllItemsArray();
            } catch (e) {
                console.error('Failed to build formalize items after loading feedback', e);
                this.formalizeItemsArray = [];
            }
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.loadingFeedbackDetailsFlag = false;
            if (this.authService.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }

    getCompanyClass() {
        if (this.companyQnsComplete) {
            return 'panel-collapse collapse';
        } else {
            return 'panel-collapse collapse in';
        }
    }

    getClientClass(keyval?) {
        if (this.checkifClientCompleted(keyval)) {
            return 'panel-collapse collapse';
        } else {
            return 'panel-collapse collapse in';
        }
    }

    getJobClass(keyval?) {
        if (this.checkifJobCompleted(keyval)) {
            return 'panel-collapse collapse';
        } else {
            return 'panel-collapse collapse in';
        }
    }

    getOverallClass() {
        if (this.checkifCompanyOverallCompleted()) {
            return 'panel-collapse collapse';
        } else {
            return 'panel-collapse collapse in';
        }
    }

    setClientJobCompleted() {
        for (const clientId in this.recruiterqns.clientListJobMatchDetails) {
            if (this.recruiterqns.clientListJobMatchDetails.hasOwnProperty(clientId)) {
                const jobArray = this.recruiterqns.clientListJobMatchDetails[clientId];
                for (let i = 0; i < jobArray.length; i++) {
                    const jobId = jobArray[i];
                    if (this.checkifClientCompleted(clientId)) {
                        this.recruiterqns.jobDetails[jobId].completed = true;
                    } else {
                        this.recruiterqns.jobDetails[jobId].completed = false;
                    }
                }
            }
        }
    }

    setNonClientJobsAsCompletedIfCompleted() {
        Object.keys(this.recruiterqns.jobDetails).forEach((key) => {
            const val = this.recruiterqns.jobDetails[key];
            if (_.isNull(val.clientName) && val.interested) {
                val.completed = true;
            }
        });
    }

    checkifCompanyCompleted() {
        this.isCompanyQuestionExists = false;
        if (this.recruiterqns === undefined || this.recruiterqns == '') {
            this.companyQnsComplete = false;
            return false;
        }

        let companykey;
        for (const key in this.recruiterqns.companyQuestionsResults) {
            if (this.recruiterqns.companyQuestionsResults.hasOwnProperty(key)) {
                companykey = key;
            }
        }
        const companyQuestion = this.recruiterqns.companyQuestionsResults[companykey];
        if (companyQuestion != null) {
            for (let i = 0; i < companyQuestion.length; i++) {
                const recruiterComment = companyQuestion[i].recruiterComment;
                const overallQuestion = companyQuestion[i].question;
                const sliderId = companyQuestion[i].rating;
                if (overallQuestion != 'Overall Comment') {
                    this.isCompanyQuestionExists = true;
                    if (this.isEmpty(recruiterComment) && sliderId == '0') {
                        this.companyQnsComplete = false;
                        return false;
                    }
                }
            }
        }
        return true;
    }

    checkifAllClientCompleted() {
        for (const key in this.recruiterqns.clientQuestionsResults) {
            if (this.recruiterqns.clientQuestionsResults.hasOwnProperty(key)) {
                const clientQuestion = this.recruiterqns.clientQuestionsResults[key];
                if (this.clientNotInterestedList.indexOf(key) > -1) {
                    continue;
                }
                if (clientQuestion != null) {
                    for (let i = 0; i < clientQuestion.length; i++) {
                        const recruiterComment = clientQuestion[i].recruiterComment;
                        const sliderId = clientQuestion[i].rating;
                        if (this.isEmpty(recruiterComment) && sliderId == '0') {
                            return false;
                        }
                    }
                }
            }
        }
        return true;
    }

    checkifClientCompleted(key) {
        const clientQuestion = this.recruiterqns.clientQuestionsResults[key];
        if (clientQuestion && clientQuestion.length > 0) {
            for (let i = 0; i < clientQuestion.length; i++) {
                const recruiterComment = clientQuestion[i].recruiterComment;
                const sliderId = clientQuestion[i].rating;
                if (this.isEmpty(recruiterComment) && sliderId == '0') {
                    return false;
                }
            }
            return true;
        } else {
            return true;
        }
    }

    checkifJobCompleted(key) {
        const jobQuestion = this.recruiterqns.jobQuestionsResults[key];
        for (let i = 0; i < jobQuestion.length; i++) {
            const recruiterComment = jobQuestion[i].recruiterComment;
            const sliderId = jobQuestion[i].rating;
            if (this.isEmpty(recruiterComment) && sliderId == '0') {
                return false;
            }
        }
        return true;
    }

    checkifAllJobCompleted() {
        for (const key in this.recruiterqns.jobQuestionsResults) {
            if (this.recruiterqns.jobQuestionsResults.hasOwnProperty(key)) {
                const jobQuestion = this.recruiterqns.jobQuestionsResults[key];
                if (this.jobNotInterestedList.indexOf(key) > -1) {
                    continue;
                }
                for (let i = 0; i < jobQuestion.length; i++) {
                    const recruiterComment = jobQuestion[i].recruiterComment;
                    const sliderId = jobQuestion[i].rating;
                    if (this.isEmpty(recruiterComment) && sliderId == '0') {
                        return false;
                    }
                }
            }
        }
        return true;
    }

    checkifCompanyOverallCompleted() {
        if (this.recruiterqns === undefined || this.recruiterqns == '') {
            return true;
        }

        let companykey;
        if (this.recruiterqns != null && this.recruiterqns.companyQuestionsResults != null) {
            for (const key in this.recruiterqns.companyQuestionsResults) {
                if (this.recruiterqns.companyQuestionsResults.hasOwnProperty(key)) {
                    companykey = key;
                }
            }

            const companyQuestion = this.recruiterqns.companyQuestionsResults[companykey];
            if (companyQuestion != null) {
                for (let i = 0; i < companyQuestion.length; i++) {
                    const recruiterComment = companyQuestion[i].recruiterComment;
                    const overallQuestion = companyQuestion[i].question;
                    const sliderId = companyQuestion[i].rating;
                    if (overallQuestion == 'Overall Comment') {
                        if (this.isEmpty(recruiterComment) && sliderId == '0') {
                            return false;
                        }
                    }
                }
            }
        }
        return true;
    }

    countJobQns() {
        return this.totalCount++;
    }

    countClientQns() {
        return this.totalClQnsCount++;
    }

    isEmpty(str) {
        return (!str || 0 === str.trim().length);
    }

    initializeSliders() {
        setTimeout(() => {
            this.initCoSliders();
            this.initClSliders();
            this.initJobSliders();

            $("div[class='overall-qn-slider']").each((i, obj) => {
                const questionId = obj.id.split('__')[1];
                const questionIndex = this.getQuestionIndex('Company', this.feedbackQuestionsCompanyId, 'id', questionId);
                const labelId = 'overall-qn-rating__' + questionId;
                $(obj).noUiSlider({
                    range: [0, 10], start: [0], step: 1, handles: 1, connect: 'lower',
                    slide: () => {
                        const val = $(obj).val();
                        $('#' + labelId).text(Math.round(val));
                        this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId][questionIndex].rating = parseInt(val, 10);
                    },
                    set: () => {
                        const val = $(obj).val();
                        $('#' + labelId).text(Math.round(val));
                        this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId][questionIndex].rating = parseInt(val, 10);
                    }
                });
                $(obj).val(this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId][questionIndex].rating, true);
            });
        }, 200);
    }

    getQuestionIndex(questionType, questionTypeId, propName, propValue) {
        let questionIndex = 0;
        let questionsArray = [];
        if (questionType == 'Company') {
            questionsArray = this.recruiterqns.companyQuestionsResults[questionTypeId];
        } else if (questionType == 'Client') {
            questionsArray = this.recruiterqns.clientQuestionsResults[questionTypeId];
        }
        if (propName == 'id') {
            questionIndex = _.findIndex(questionsArray, { id: propValue });
        } else if (propName == 'question') {
            questionIndex = _.findIndex(questionsArray, { question: propValue });
        }
        return questionIndex;
    }

    initCoSliders() {
        $("div[class='co-qn-slider']").each((i, obj) => {
            const questionId = obj.id.split('__')[1];
            const questionIndex = this.getQuestionIndex('Company', this.feedbackQuestionsCompanyId, 'id', questionId);
            const labelId = 'co-qn-rating__' + questionId;
            $(obj).noUiSlider({
                range: [0, 10], start: [0], step: 1, handles: 1, connect: 'lower',
                slide: () => {
                    const val = $(obj).val();
                    $('#' + labelId).text(Math.round(val));
                    this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId][questionIndex].rating = parseInt(val, 10);
                },
                set: () => {
                    const val = $(obj).val();
                    $('#' + labelId).text(Math.round(val));
                    this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId][questionIndex].rating = parseInt(val, 10);
                }
            });
            $(obj).val(this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId][questionIndex].rating, true);
        });
    }

    initClSliders() {
        $("div[class='cl-qn-slider']").each((i, obj) => {
            const clientId = obj.id.split('__')[1];
            const questionId = obj.id.split('__')[2];
            const questionIndex = this.getQuestionIndex('Client', clientId, 'id', questionId);
            const labelId = 'cl-qn-rating__' + clientId + '__' + questionId;
            $(obj).noUiSlider({
                range: [0, 10], start: [0], step: 1, handles: 1, connect: 'lower',
                slide: () => {
                    const val = $(obj).val();
                    $('#' + labelId).text(Math.round(val));
                    this.recruiterqns.clientQuestionsResults[clientId][questionIndex].rating = parseInt(val, 10);
                },
                set: () => {
                    const val = $(obj).val();
                    $('#' + labelId).text(Math.round(val));
                    this.recruiterqns.clientQuestionsResults[clientId][questionIndex].rating = parseInt(val, 10);
                }
            });
            $(obj).val(this.recruiterqns.clientQuestionsResults[clientId][questionIndex].rating, true);
        });
    }

    initJobSliders() {
        $("div[id='job-qn-slider']").each((i, obj) => {
            const labelId = '#job-qn-rating' + ++i;
            $(obj).noUiSlider({
                range: [0, 10], start: [0], step: 1, handles: 1, connect: 'lower',
                slide: () => {
                    const val = $(obj).val();
                    $(labelId).text(Math.round(val));
                },
                set: () => {
                    const val = $(obj).val();
                    $(labelId).text(Math.round(val));
                }
            });
            const qnRating = $(labelId).text();
            $(obj).val(qnRating, true);
        });
    }

    filterFunction = (element) => {
        return element.question.match(/^Overall/) ? false : true;
    }

    filterFunctionForOverall = (element) => {
        if (element != null) {
            return element.question.match(/^Overall/) ? true : false;
        }
    }

    // Template helpers standing in for AngularJS' `| filter:` pipe (removed
    // in Angular) - same predicates as filterFunction/filterFunctionForOverall.
    getNonOverallQuestions(list: any[]): any[] {
        return list ? list.filter(this.filterFunction) : [];
    }

    getOverallQuestions(values: any): any[] {
        const out = [];
        if (!values) { return out; }
        Object.keys(values).forEach(key => {
            (values[key] || []).filter(this.filterFunctionForOverall).forEach(q => out.push(q));
        });
        return out;
    }

    // Stands in for AngularJS' ng-init="$ctrl.filterByInterested()" inside
    // the overall-comments ng-repeat; safe to invoke repeatedly (idempotent).
    onOverallRowInit(): string {
        this.filterByInterested();
        return '';
    }

    clearObjects() {
        this.recruiterqns = '';
    }

    filterByInterested() {
        if (this.clientOrBuExists && this.feedbackType != 'Outreach') {
            for (const clientId in this.recruiterqns.clientListJobMatchDetails) {
                if (this.recruiterqns.clientListJobMatchDetails.hasOwnProperty(clientId)) {
                    let showClient = false;
                    const jobArray = this.recruiterqns.clientListJobMatchDetails[clientId];
                    for (let i = 0; i < jobArray.length; i++) {
                        const jobId = jobArray[i];
                        if (this.recruiterqns.jobDetails[jobId].interested) {
                            showClient = true;
                        }
                        const y = document.getElementById(clientId);
                        if (showClient) {
                            y.style.display = 'block';
                        } else {
                            y.style.display = 'none';
                        }
                    }
                }
            }
        }
    }

    toDisplayJobPanel(jobMatchId) {
        const jobQuestionList = this.recruiterqns.jobQuestionsResults[jobMatchId];
        if (jobQuestionList == null || jobQuestionList.length == 0) {
            return false;
        } else {
            return true;
        }
    }

    toDisplayClientPanel(clientKey) {
        const clientQuestionList = this.recruiterqns.clientQuestionsResults[clientKey];
        if (clientQuestionList == null) {
            return false;
        } else {
            return true;
        }
    }

    isClientJobEnabled(clientId) {
        const jobArray = this.recruiterqns.clientListJobMatchDetails[clientId];
        let isClientJobEnabledFlag = false;
        jobArray.forEach((jobId, key) => {
            if (this.recruiterqns.jobDetails[jobId].interested) {
                isClientJobEnabledFlag = true;
            }
        });
        return isClientJobEnabledFlag;
    }

    closeModal() {
        if (!_.isUndefined(this.completeFeedbackCallback)) {
            this.completeFeedbackCallback.emit();
        }
    }

    _checkIfContactDetailsMissing() {
        const candidateJobMatch = _.cloneDeep(this.candidateJobMatch);
        candidateJobMatch.candidateAdditionalDetails.workLocations = this.candidateJobMatch.workLocations;
        this.isCandidateContactDetailsMissing = !this.sharedService.isContactDetailsAvailable(candidateJobMatch, 'candidateJobMatchCard');
        this.isCandidateContactAdditionalDetailsMissing = !this.sharedService.isCandidateAdditionalDetailsAvailable(candidateJobMatch);

        if (this.isCandidateContactAdditionalDetailsMissing) {
            if (this.candidateContactDetailsMissingCallback) {
                this.candidateContactDetailsMissingCallback.emit({ result: true });
            }
        } else {
            if (this.candidateContactDetailsMissingCallback) {
                this.candidateContactDetailsMissingCallback.emit({ result: false });
            }
        }
    }

    _setCandidateMissingDetailsMessage(contactDetails, additionalDetails) {
        const message = [];
        if (contactDetails) {
            if (!this.candidateJobMatch.email) { message.push('Email'); }
            if (!this.candidateJobMatch.mobilephone) { message.push('Phone Number'); }
            if ((!this.candidateJobMatch.address || (!this.candidateJobMatch.address.zipcode || this.candidateJobMatch.address.zipcode == ''))) { message.push('Zip code'); }
        }

        if (additionalDetails) {
            if (!this.candidateJobMatch.candidateAdditionalDetails) {
                message.push('Preferred JobType', 'Salary', 'Work Authorization', 'Work Location');
            } else {
                if (!this.candidateJobMatch.candidateAdditionalDetails.preferredJobTypeDetails || this.candidateJobMatch.candidateAdditionalDetails.preferredJobTypeDetails.jobType.length === 0) { message.push('Preferred JobType', 'Salary'); }
                if (!this.candidateJobMatch.candidateAdditionalDetails.sponsorships || this.candidateJobMatch.candidateAdditionalDetails.sponsorships.length === 0) { message.push('Work Authorization'); }
                if (!this.candidateJobMatch.workLocations || this.candidateJobMatch.workLocations.length === 0) { message.push('Work Locations'); }
            }
        }

        return message.toString().replace(/,/g, ', ');
    }

    _checkCandidateMissingInfo(successCallback, cancelCallback) {
        const contactMissingInfoMessage = this._setCandidateMissingDetailsMessage(this.isCandidateContactDetailsMissing, this.isCandidateContactAdditionalDetailsMissing);
        const title = 'Missing Information';
        const message = `<div>
                            <p>The useful information of the candidate <span>'<span class="emerald">${contactMissingInfoMessage}</span>'</span> is missing and needs to be entered.<p>
                            <p>Complete anyway?</p>
                        </div>`;
        this.alertsAndNotificationsService.showConfirm(title, message, 'warning', true, () => {
            if (successCallback) {
                successCallback();
            }
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        }, () => {
            if (cancelCallback) {
                cancelCallback();
            }
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        });
    }

    completeModal(fromButton) {
        this.saveResults(fromButton);
    }

    cancelModal() {
        let showConfirmationPopup = false;
        if (!_.isEqual(this.savedRecruiterQns, this.recruiterqns) || !_.isEqual(this.savedCandidateAdditionalDetails, this.candidateAdditionalDetails)) {
            showConfirmationPopup = true;
        }
        if (showConfirmationPopup) {
            this.alertsAndNotificationsService.showCustomConfirm('Yes', 'Cancel', 'Warning!', 'Unsaved data on the page will be lost.<br><br> Do you still want to continue?', 'warning', undefined, () => {
                if (!_.isUndefined(this.closeModal)) {
                    this.closeModal();
                }
            }, () => {
                // do nothing
            });
        } else {
            if (!_.isUndefined(this.closeModal)) {
                this.closeModal();
            }
        }
    }

    addQuestion(category, categoryId) {
        let sliderIdPrefix = '';
        let sliderTextIdPrefix = '';
        let newQuestion: any = {};
        if (category == 'Company') {
            newQuestion = this._createDuplicateQuestion(this.recruiterqns.companyQuestionsResults[categoryId][0], categoryId, 'company');
            this.recruiterqns.companyQuestionsResults[categoryId].push(newQuestion);
            sliderIdPrefix = 'co-qn-slider';
            sliderTextIdPrefix = 'co-qn-rating';
        } else if (category == 'Client') {
            newQuestion = this._createDuplicateQuestion(this.recruiterqns.clientQuestionsResults[categoryId][0], categoryId, 'clientOrBu');
            this.recruiterqns.clientQuestionsResults[categoryId].push(newQuestion);
            sliderIdPrefix = 'cl-qn-slider__' + categoryId;
            sliderTextIdPrefix = 'cl-qn-rating__' + categoryId;
        }
        setTimeout(() => {
            const questionIndex = this.getQuestionIndex(category, categoryId, 'id', newQuestion.id);
            $('#' + sliderIdPrefix + '__' + newQuestion.id).noUiSlider({
                range: [0, 10], start: [0], step: 1, handles: 1, connect: 'lower',
                slide: () => {
                    const val = $('#' + sliderIdPrefix + '__' + newQuestion.id).val();
                    $('#' + sliderTextIdPrefix + '__' + newQuestion.id).text(Math.round(val));
                    if (category == 'Company') {
                        this.recruiterqns.companyQuestionsResults[categoryId][questionIndex].rating = parseInt(val, 10);
                    } else {
                        this.recruiterqns.clientQuestionsResults[categoryId][questionIndex].rating = parseInt(val, 10);
                    }
                },
                set: () => {
                    const val = $('#' + sliderIdPrefix + '__' + newQuestion.id).val();
                    $('#' + sliderTextIdPrefix + '__' + newQuestion.id).text(Math.round(val));
                    if (category == 'Company') {
                        this.recruiterqns.companyQuestionsResults[categoryId][questionIndex].rating = parseInt(val, 10);
                    } else {
                        this.recruiterqns.clientQuestionsResults[categoryId][questionIndex].rating = parseInt(val, 10);
                    }
                }
            });
            $('#' + sliderIdPrefix + '__' + newQuestion.id).val(0, true);
        }, 200);
    }

    removeQuestion(category, categoryId, questionId) {
        let questionsArray = [];
        if (category == 'Company') {
            questionsArray = this.recruiterqns.companyQuestionsResults[categoryId];
        } else if (category == 'Client') {
            questionsArray = this.recruiterqns.clientQuestionsResults[categoryId];
        }
        const questionIndex = this.getQuestionIndex(category, categoryId, 'id', questionId);
        questionsArray.splice(questionIndex, 1);
    }

    _createDuplicateQuestion(question, companyClientOrBuId, companyType) {
        let questionDuplicate: any = {};
        if (!_.isUndefined(question)) {
            questionDuplicate = _.cloneDeep(question);
        }
        questionDuplicate.question = '';
        questionDuplicate.rating = 0;
        questionDuplicate.recruiterComment = null;
        questionDuplicate.questionareDateTime = null;
        questionDuplicate.userId = null;
        questionDuplicate.id = Math.floor((Math.random() * 100) + 1).toString();
        questionDuplicate.recruiterName = null;
        questionDuplicate.questionType = null;
        questionDuplicate.lastModifiedBy = null;
        questionDuplicate.participantId = null;
        questionDuplicate.jobmatchId = null;
        questionDuplicate.newQuestionFlag = true;
        questionDuplicate.candidateId = this.candidateId;
        if (companyType == 'clientOrBu') {
            questionDuplicate.clientorbuId = companyClientOrBuId;
            questionDuplicate.companyId = this.companyId;
            questionDuplicate.externalComment = null;
            questionDuplicate.questionOrder = 0;
        }

        return questionDuplicate;
    }

    saveResults(fromButton, successCallback?: () => void) {
        if (fromButton == 'save' && this.feedbackType == 'Screening') {
            const feedbackSaveNeeded = !_.isEqual(this.savedRecruiterQns, this.recruiterqns);
            const candidateAdditionalDetailsSaveNeeded = !_.isEqual(this.savedCandidateAdditionalDetails, this.candidateAdditionalDetails);
            const hasUnselectedJobs = this._hasUnSelectedJobs();

            if (hasUnselectedJobs) {
                this._showUnSelectedJobsModal();
            } else if (!feedbackSaveNeeded && !candidateAdditionalDetailsSaveNeeded) {
                this._showNoDataToSaveModal();
            } else if (feedbackSaveNeeded && candidateAdditionalDetailsSaveNeeded) {
                this._saveFeedback(fromButton, () => {
                    this._saveCandidateAdditionalDetails(false);
                });
            } else if (feedbackSaveNeeded) {
                this._saveFeedback(fromButton);
            } else if (candidateAdditionalDetailsSaveNeeded) {
                this._saveCandidateAdditionalDetails(true);
            }
        } else if (fromButton == 'save' && this.feedbackType !== 'Screening') {
            if (!this._hasFeedbackChanged()) {
                this._showNoDataToSaveModal();
            } else {
                this._saveFeedback(fromButton);
            }
        } else if (fromButton === 'complete' && this.feedbackType == 'Screening') {
            if (this._hasUnSelectedJobs()) {
                this._showUnSelectedJobsModal();
            } else {
                this._checkIfContactDetailsMissing();
                if (this.completeButtonLabel != 'Update' && (this.isCandidateContactDetailsMissing || this.isCandidateContactAdditionalDetailsMissing)) {
                    this._checkCandidateMissingInfo(() => {
                        this._saveFeedback(fromButton, () => {
                            if (!_.isEqual(this.savedCandidateAdditionalDetails, this.candidateAdditionalDetails)) {
                                this._saveCandidateAdditionalDetails(false);
                            }
                        });
                    }, () => {
                        if (this._hasFeedbackChanged()) {
                            this._saveFeedback('save');
                        }
                    });
                } else {
                    this._saveFeedback(fromButton, () => {
                        if (!_.isEqual(this.savedCandidateAdditionalDetails, this.candidateAdditionalDetails)) {
                            this._saveCandidateAdditionalDetails(false);
                        }
                    });
                }
            }
        } else {
            this._checkIfContactDetailsMissing();
            if (this.completeButtonLabel != 'Update' && fromButton === 'complete' && (this.isCandidateContactDetailsMissing || this.isCandidateContactAdditionalDetailsMissing)) {
                this._checkCandidateMissingInfo(() => {
                    this._saveFeedback(fromButton, () => {
                        if (!_.isEqual(this.savedCandidateAdditionalDetails, this.candidateAdditionalDetails)) {
                            this._saveCandidateAdditionalDetails(false);
                        }
                    });
                }, () => {
                    if (this._hasFeedbackChanged()) {
                        this._saveFeedback('save');
                    }
                });
            } else {
                this._saveFeedback(fromButton);
            }
        }
    }

    _hasUnSelectedJobs() {
        for (const jobId in this.recruiterqns.jobDetails) {
            if (this.recruiterqns.jobDetails.hasOwnProperty(jobId)) {
                if (this.feedbackType == 'Screening' && this.recruiterqns.jobDetails[jobId].interested == null) {
                    return true;
                }
            }
        }
        return false;
    }

    _hasFeedbackChanged() {
        return !_.isEqual(this.savedRecruiterQns, this.recruiterqns);
    }

    _saveFeedback(fromButton, successCallback?: () => void) {
        let listofCompanyQuestions;
        let listofClientQuestions = [];
        let listofJobQuestions = [];
        let companyCompleted = true;
        let clientAllCompleted = true;
        let newQuestionErrorExistFlag = false;
        let joballCompleted = true;
        let participantId = '';
        let companyOverallCompleted = true;
        if (this.userList.length == 1) {
            participantId = this.userList[0].id;
        } else {
            participantId = this.userGetRecruiterQns;
        }
        if (this.recruiterqns != null) {

            this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId].forEach((val, key) => {
                val.questionareDateTime = this.dateTimeUtilityService.getCurrentTimeStampInAPIFormat();
                val.questionType = this.type;
                val.lastModifiedBy = _.isNull(this.userId) ? this.loggedInUserId : this.userId;
                val.participantId = participantId;
                if (val.question != 'Overall Comment') {
                    if (val.rating == '0' && this.isEmpty(val.recruiterComment)) {
                        companyCompleted = false;
                    }
                    if (!_.isUndefined(val.newQuestionFlag) && val.question.trim() == '') {
                        newQuestionErrorExistFlag = true;
                    }
                } else if (val.question == 'Overall Comment') {
                    if (val.rating == '0' && this.isEmpty(val.recruiterComment)) {
                        companyOverallCompleted = false;
                    }
                }
            });
            listofCompanyQuestions = this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId];

            Object.keys(this.recruiterqns.clientQuestionsResults).forEach((clientKey) => {
                const clientVal = this.recruiterqns.clientQuestionsResults[clientKey];
                if (this.isClientJobEnabled(clientKey)) {
                    clientVal.forEach((val, key) => {
                        val.questionareDateTime = this.dateTimeUtilityService.getCurrentTimeStampInAPIFormat();
                        val.questionType = this.type;
                        val.lastModifiedBy = _.isNull(this.userId) ? this.loggedInUserId : this.userId;
                        val.participantId = participantId;
                        if (val.rating == '0' && this.isEmpty(val.recruiterComment)) {
                            clientAllCompleted = false;
                        }
                        if (!_.isUndefined(val.newQuestionFlag) && val.question.trim() == '') {
                            newQuestionErrorExistFlag = true;
                        }
                    });
                    if (listofClientQuestions) {
                        listofClientQuestions = listofClientQuestions.concat(clientVal);
                    } else {
                        listofClientQuestions = clientVal;
                    }
                }
            });

            for (const key in this.recruiterqns.jobQuestionsResults) {
                if (this.recruiterqns.jobQuestionsResults.hasOwnProperty(key) && this.toDisplayJobPanel(key)) {
                    const spanId = 'job-qn' + key;
                    $('span[id=' + spanId + ']').each((i, obj) => {
                        const jobQnNoFldId = 'job-qn-no' + key;
                        const jobQnNo = $('input[id=' + jobQnNoFldId + ']')[i].value;
                        const sliderId = '#job-qn-rating' + jobQnNo;
                        const textAreaId = '#job-qn-comments' + jobQnNo;
                        this.recruiterqns.jobQuestionsResults[key][i].rating = $(sliderId).text();
                        this.recruiterqns.jobQuestionsResults[key][i].recruiterComment = $(textAreaId).val();
                        this.recruiterqns.jobQuestionsResults[key][i].questionareDateTime = this.dateTimeUtilityService.getCurrentTimeStampInAPIFormat();
                        this.recruiterqns.jobQuestionsResults[key][i].questionType = this.type;
                        this.recruiterqns.jobQuestionsResults[key][i].lastModifiedBy = _.isNull(this.userId) ? this.loggedInUserId : this.userId;
                        this.recruiterqns.jobQuestionsResults[key][i].participantId = participantId;
                        if (this.recruiterqns.jobQuestionsResults[key][i].rating == '0' && this.isEmpty(this.recruiterqns.jobQuestionsResults[key][i].recruiterComment)) {
                            joballCompleted = false;
                        }
                    });

                    if (listofJobQuestions) {
                        listofJobQuestions = listofJobQuestions.concat(this.recruiterqns.jobQuestionsResults[key]);
                    } else {
                        listofJobQuestions = this.recruiterqns.jobQuestionsResults[key];
                    }
                    const jobQuestionList = this.recruiterqns.jobQuestionsResults[key];
                    if (jobQuestionList == null || jobQuestionList.length == 0) {
                        joballCompleted = true;
                    }
                }
            }

            const listOfCompanyquest = listofCompanyQuestions ? listofCompanyQuestions.concat(listofClientQuestions) : [];
            const listOfQuestionsResults = listOfCompanyquest;

            this.setClientJobCompleted();
            this.setNonClientJobsAsCompletedIfCompleted();

            if (companyCompleted && clientAllCompleted && companyOverallCompleted) {
                this.feedbackExecutionResult.companyAndOverallComplete = 'complete';
            } else {
                this.feedbackExecutionResult.companyAndOverallComplete = 'notcomplete';
            }

            const listOfjobdetails = [];

            for (const key in this.recruiterqns.jobDetails) {
                if (this.recruiterqns.jobDetails.hasOwnProperty(key)) {
                    listOfjobdetails.push(this.recruiterqns.jobDetails[key]);
                }
            }

            this.feedbackExecutionResult.companyId = this.companyId;
            this.feedbackExecutionResult.feedbackAnswersList = listOfQuestionsResults;
            this.feedbackExecutionResult.jobDetailsRecruiterScreeningList = listOfjobdetails;
            this.feedbackExecutionResult.fromButton = fromButton;
            this.feedbackExecutionResult.meetingScheduleId = this.feedbackType == 'Screening' ? null : this.chosenMeeting.meetingScheduleId;
            this.feedbackExecutionResult.externalMeetingId = this.feedbackType == 'Screening' && !this.externalMeetingCallId ? null : this.externalMeetingCallId;
            if (newQuestionErrorExistFlag) {
                this.alertsAndNotificationsService.showAlert('Question not provided!', 'Question cannot be empty. <br>Please provide a question and its rating for all the new questions added.', 'warning');
            } else if (fromButton === 'complete' && (!companyCompleted || !clientAllCompleted || !companyOverallCompleted)) {
                let message = 'Please answer all the questions to complete the feedback form.';
                if (this.completeButtonLabel == 'Update') {
                    message = 'Please answer all the questions to update the feedback form.';
                }
                this.alertsAndNotificationsService.showAlert('Incomplete Form!', message, 'warning');
            } else if (((this.feedbackType == 'Screening' && this.candidateJobMatch.jobMatchCurrentState == 'Activated') || ((this.feedbackType == 'Interview' || this.feedbackType == 'PhoneScreen' || this.feedbackType == 'RecruiterScreening') && this.chosenMeeting.status == 'COMPLETED')) && (!companyCompleted || !clientAllCompleted || !companyOverallCompleted)) {
                this.alertsAndNotificationsService.showAlert('Incomplete Form!', 'You are saving a Completed Feedback form. Please answer all the questions.', 'warning');
            } else {
                if (fromButton == 'save') {
                    this.savingFlag = true;
                } else if (fromButton == 'complete') {
                    this.completingFlag = true;
                }
                this.feedbackExecutionResult.feedbackAnswersList.forEach((val, key) => {
                    if (!_.isUndefined(val.newQuestionFlag)) {
                        val.id = null;
                        delete val.newQuestionFlag;
                    } else if (!_.isUndefined(val.randomIdCreatedFlag)) {
                        val.id = null;
                        delete val.randomIdCreatedFlag;
                    }
                });
                let loggedInUserId = null;
                if (!this.loginRequired) {
                    loggedInUserId = this.loggedInUserId;
                }
                this.feedbackExecutionService.saveRecruiterQuestions(this.feedbackExecutionResult, this.jobMatchId, loggedInUserId, (data) => {
                    if (successCallback) {
                        successCallback();
                    }
                    if (fromButton == 'save') {
                        this.savingFlag = false;
                        if (!_.isUndefined(this.saveCallback)) {
                            this.saveCallback.emit();
                        }
                        this.init(true);
                    } else if (fromButton == 'complete') {
                        let feedbackTypeLabel = 'Screening';
                        let completeTypeLabel = 'completed';
                        this.completingFlag = false;
                        if (this.feedbackType == 'Screening') {
                            if (this.candidateJobMatch.jobMatchCurrentState == 'Activated') {
                                completeTypeLabel = 'updated';
                            }
                        } else if (this.feedbackType == 'Interview' || this.feedbackType == 'PhoneScreen' || this.feedbackType == 'RecruiterScreening') {
                            feedbackTypeLabel = this.feedbackType == 'Interview' ? 'Interview' : (this.feedbackType == 'PhoneScreen' ? 'Phone Screen' : 'Recruiter Screening');
                            if (this.chosenMeeting.status == 'COMPLETED') {
                                completeTypeLabel = 'updated';
                            }
                        }
                        const successMessage = 'The ' + feedbackTypeLabel + ' Feedback has been ' + completeTypeLabel + ' successfully.';
                        this.alertsAndNotificationsService.showAlertWithCallBack('Success!', successMessage, 'success', () => {
                            if (this.completeFeedbackCallback.observers.length > 0) {
                                setTimeout(() => {
                                    this.completeFeedbackCallback.emit();
                                    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                                }, 300);
                            } else {
                                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                                this.init(true);
                            }
                        });
                    }
                }, (error) => {
                    this.savingFlag = false;
                    this.completingFlag = false;
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                });
            }

        }
    }

    _saveCandidateAdditionalDetails(isSuccessMessageNeeded) {
        this.candidateService.addOrUpdateCandidateAdditionalDetails(this.candidateAdditionalDetails, (data) => {
            if (isSuccessMessageNeeded) {
                this.alertsAndNotificationsService.showBannerMessage(data.message, 'success');
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    _showUnSelectedJobsModal() {
        let message = 'Some job matches have not been marked as Interested or Not Interested.';
        let isAllJobMatchesUnselected = true;
        for (const jobId in this.recruiterqns.jobDetails) {
            if (this.recruiterqns.jobDetails.hasOwnProperty(jobId) && this.recruiterqns.jobDetails[jobId].interested !== null) {
                isAllJobMatchesUnselected = false;
                break;
            }
        }
        if (isAllJobMatchesUnselected) {
            message = 'None of the job matches have been marked as Interested or Not Interested';
        }

        this.alertsAndNotificationsService.showAlert('Alert!', message, 'warning');
    }

    _showNoDataToSaveModal() {
        this.alertsAndNotificationsService.showAlert('Alert!', 'Nothing to Save!', 'warning');
    }

    markAllJobsAsInterested() {
        for (const jobId in this.recruiterqns.jobDetails) {
            if (this.recruiterqns.jobDetails.hasOwnProperty(jobId)) {
                this.recruiterqns.jobDetails[jobId].interested = true;
            }
        }

        this.filterByInterested();
    }

    onInternalNoteChanged() {
        const indexOfOverallQuestion = this._getIndexOfOverallQuestion();
        this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId][indexOfOverallQuestion].externalComment = this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId][indexOfOverallQuestion].recruiterComment;
    }

    onExternalNoteChange(event) {
        const indexOfOverallQuestion = this._getIndexOfOverallQuestion();
        this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId][indexOfOverallQuestion].externalComment = event.externalNote;
    }

    _getIndexOfOverallQuestion() {
        return this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId].findIndex(question => question.question == 'Overall Comment');
    }

    onCopyNoteChange(event) {
        this.copyNote = event.copyNote;
    }

    openConference(meeting) {
        window.open(meeting.meetingUrl, '_blank');
    }

    toggleCompanyQuestionComments() {
        this.showAllCompanyQuestionComments = !this.showAllCompanyQuestionComments;
        this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId].forEach((val, key) => {
            val.showComment = this.showAllCompanyQuestionComments;
        });
    }

    toggleClientQuestionComments(clientId) {
        this.showAllClientQuestionComments = !this.showAllClientQuestionComments;
        this.recruiterqns.clientQuestionsResults[clientId].forEach((val, key) => {
            val.showComment = this.showAllClientQuestionComments;
        });
    }

    // ------------------------------------------------------------------
    // Actions modal call sites - ported from $uibModal.open({component:
    // 'feedbackExecutionActionsModal', resolve: {...}}).result.then(...)
    // onto BsModalService.show(...) + onClose Subject subscription.
    // ------------------------------------------------------------------
    viewJobProfile(jobId) {

        setTimeout(() => {
            const modalRef = this.bsModalService.show(FeedbackExecutionActionsModalComponent, {
                animated: true,
                class: 'custom-modal-xl',
                backdrop: 'static',
                keyboard: false,
                initialState: {
                    actionType: 'jobProfile',
                    jobId
                }
            });
            modalRef.content.onClose.subscribe((callback) => {
            });
        }, 300);
    }

    viewCandidateBooklet(meeting?) {
        const meetingId = meeting ? meeting.id : this.parentScheduleId;
        const usersList = meeting ? meeting.userList : this.feedbackUserIdsList;

        setTimeout(() => {
            const modalRef = this.bsModalService.show(FeedbackExecutionActionsModalComponent, {
                animated: true,
                class: 'custom-modal-xl',
                backdrop: 'static',
                keyboard: false,
                initialState: {
                    actionType: 'candidateBooklet',
                    candidateId: this.candidateJobMatch.id,
                    jobId: this.candidateJobMatch.jobMatchJobId,
                    jobMatchId: this.jobMatchId,
                    feedbackType: this.feedbackType,
                    feedbackUserIdsList: usersList,
                    scheduleId: meetingId
                }
            });
            modalRef.content.onClose.subscribe((callback: any) => {
                if (callback && callback.callbackType == 'refresh') {
                    this.completeFeedbackCallback.emit();
                }
            });
        }, 300);
    }

    onUserWhoCanEditFeedbackChange() {
        this.enabledEditForUser = this.usersToEditFeedback.find(user => user.attendeeId == this.enableEditForAttendeeId);
        if (_.isEqual(this.savedRecruiterQns, this.recruiterqns)) {
            this._confirmEnablingUserToEdit();
        } else {
            this._alertUserToSaveTheFeedback();
        }
    }

    _confirmEnablingUserToEdit() {
        const message = `Only '${this.enabledEditForUser.displayName}' will be allowed to edit the feedback.<br><br> Do you want to continue?`;
        this.alertsAndNotificationsService.showCustomConfirm('Yes', 'Cancel', 'Confirm', message, 'warning', undefined, () => {
            this._approveUserToEditFeedback(true);
        }, () => {
            this._selectPreviousUser();
        });
    }

    _selectPreviousUser() {
        this.loadingUsers = true;
        this.enabledEditForUser = _.cloneDeep(this.previousEnableEditFor);
        if (this.previousEnableEditFor !== null) {
            this.enableEditForAttendeeId = this.previousEnableEditFor.attendeeId;
        } else {
            this.enableEditForAttendeeId = this.previouslyEnabledEditForAttendeeId;
            this.enabledEditForUser = this.usersToEditFeedback.find(user => user.attendeeId == this.enableEditForAttendeeId);
        }
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        setTimeout(() => {
            this.loadingUsers = false;
        }, 1000);
    }

    _alertUserToSaveTheFeedback() {
        this.enabledEditForUser = _.cloneDeep(this.previousEnableEditFor);
        if (this.previousEnableEditFor == null) {
            this.enableEditForAttendeeId = null;
        }
        this.alertsAndNotificationsService.showAlertWithCallBack('Feedback is not saved!', 'Please save your feedback.', 'warning', () => {
            this._selectPreviousUser();
        });
    }

    _approveUserToEditFeedback(isApproved, requesterAttendeeId?) {
        const currentUserAttendeeId = this.usersToEditFeedback.find(user => user.displayName == 'You').attendeeId;
        const enableEditForAttendeeId = isApproved ? this.enableEditForAttendeeId : requesterAttendeeId;
        const attendeeIds = this.usersToEditFeedback.map(attendee => attendee.attendeeId);
        const approvalDetails = {
            attendeeId: enableEditForAttendeeId,
            approverId: currentUserAttendeeId,
            meetingScheduleId: this.parentScheduleId,
            externalMeetingCallId: this.externalMeetingCallId,
            attendeeIds,
            approved: isApproved
        };
        this.meetingService.giveFeedbackEditApproval(approvalDetails, (data) => {
            if (isApproved) {
                this.previousEnableEditFor = _.cloneDeep(this.enabledEditForUser);
            }
        }, error => {
            this.alertsAndNotificationsService.showToastMessage(error.message, 'danger');
        });
    }

    requestPermissionToEdit() {
        const currentUserAttendeeId = this.usersToEditFeedback.find(user => user.displayName === 'You').attendeeId;
        const requestDetails = {
            attendeeId: this.enableEditForAttendeeId,
            externalMeetingCallId: this.externalMeetingCallId,
            requesterAttendeeId: currentUserAttendeeId
        };

        this.meetingService.getFeedbackEditRequestApproval(requestDetails, (data) => {
            if (data) {
                this.alertsAndNotificationsService.showAlert('Request sent!', `Request to edit feedback sent.`, 'success');
            } else {
                this.alertsAndNotificationsService.showAlert('Request not sent', 'Request to edit feedback not sent. Please try after some time.', 'warning');
            }
        }, error => {
            this.alertsAndNotificationsService.showAlert('Request not sent', 'Request to edit feedback not sent. Please try after some time.', 'warning');
        });
    }

    openEditFeedbackApprovalModal(message) {
        this.modalService.closeAllOpenModals();
        const editFeedbackApprovalInfo = {
            requesterName: message.requesterName,
            isFeedbackChanged: this._hasFeedbackChanged()
        };
        const modalRef = this.bsModalService.show(FeedbackExecutionActionsModalComponent, {
            animated: true,
            class: 'custom-modal-65',
            backdrop: 'static',
            keyboard: false,
            initialState: {
                actionType: 'feedbackEditApproval',
                editFeedbackApprovalInfo
            }
        });
        modalRef.content.onClose.subscribe((callback: any) => {
            if (callback && callback.callbackType == 'saveAndApproveFeedbackEdit') {
                this.enableEditForAttendeeId = message.requesterAttendeeId;
                if (this._hasFeedbackChanged()) {
                    this._saveFeedback('save', () => {
                        this._approveUserToEditFeedback(true);
                    });
                } else {
                    this._approveUserToEditFeedback(true);
                }
            } else if (callback && callback.callbackType == 'approveFeedbackEdit') {

                if (editFeedbackApprovalInfo.isFeedbackChanged) {
                    this.alertsAndNotificationsService.showConfirm('Warning!', 'The changes you made to the feedback will not be saved.<br><br> Do you still want to continue?', 'warning', true, () => {
                        this.enableEditForAttendeeId = message.requesterAttendeeId;
                        this._approveUserToEditFeedback(true);
                    }, () => {
                        // do nothing
                    });
                } else {
                    this.enableEditForAttendeeId = message.requesterAttendeeId;
                    this._approveUserToEditFeedback(true);
                }
            } else if (callback && callback.callbackType == 'denyFeedbackEdit') {
                this._approveUserToEditFeedback(false, message.requesterAttendeeId);
            }
        });
    }

    _checkAndSaveFeedbackIfMeetingEnd() {
        this.meetingEventSubscriptions.add(this.meetingService.saveFeedbackOnMeetingEnd.subscribe((resolveCallback) => {
            if (this._hasFeedbackChanged()) {
                this._saveFeedback('save', resolveCallback);
            } else {
                resolveCallback();
            }
        }));
    }

    getOutreachFeedbackQuestions() {
        this.loadingFeedbackDetailsFlag = true;
        if (this.outreachData) {
            this.setOutreachFeedbackData(this.outreachData);
        } else {
            this.outreachService.getOutreachFeedbackQuestions(this.candidateId, this.companyId, (data) => {
                this.setOutreachFeedbackData(data);
            }, (error) => {
                this.alertsAndNotificationsService.showToastMessage(error.message, 'danger');
            });
        }
    }

    setOutreachQuestionsForFeedback(clientIds) {
        if (this.recruiterqns && this.recruiterqns.clientDetails && clientIds) {
            Object.keys(this.recruiterqns.clientDetails).forEach(clientId => {
                const el = document.getElementById(clientId);
                if (el) {
                    if (clientIds.includes(clientId)) {
                        el.style.display = 'block';
                    } else {
                        el.style.display = 'none';
                    }
                }
            });
        }
    }

    setOutreachFeedbackData(data) {
        this.loadingFeedbackDetailsFlag = false;
        this.recruiterqns = _.cloneDeep(data);
        this.recruiterqns.readOnly = true;
        this.feedbackQuestionsCompanyId = null;
        Object.keys(this.recruiterqns.companyQuestionsResults).forEach((key) => {
            this.feedbackQuestionsCompanyId = key;
        });

        this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId].forEach((val, key) => {
            if (_.isNull(val.id)) {
                val.id = Math.floor((Math.random() * 100) + 1).toString();
                val.isIdValid = false;
                val.randomIdCreatedFlag = true;
                val.showComment = true;
            } else {
                val.isIdValid = true;
            }
        });
        Object.keys(this.recruiterqns.clientQuestionsResults).forEach((clientKey) => {
            const clientVal = this.recruiterqns.clientQuestionsResults[clientKey];
            clientVal.forEach((val, key) => {
                if (_.isNull(val.id)) {
                    val.id = Math.floor((Math.random() * 100) + 1).toString();
                    val.isIdValid = false;
                    val.randomIdCreatedFlag = true;
                    val.showComment = true;
                } else {
                    val.isIdValid = true;
                }
            });
        });
        if (this.recruiterqns.sortedClientList.length == 0) {
            this.clientOrBuExists = false;
        }
        this.displayQuestions = true;
        for (const key in this.recruiterqns.jobDetails) {
            if (this.recruiterqns.jobDetails.hasOwnProperty(key)) {
                const jobDetailval = this.recruiterqns.jobDetails[key];
                this.type = jobDetailval.feedbackType;
                break;
            }
        }
        if (this.type != 'R') {
            this.showInterested = false;
        }
        this.savedRecruiterQns = _.cloneDeep(this.recruiterqns);
        this.checkifCompanyCompleted();
        this.initializeSliders();
        this.showMeetingLink = false;
        this.loadingFeedbackOptionsFlag = false;
        this.userHasAccessToFeedback = true;
        this.loadingFeedbackDetailsFlag = false;
        this.loadingJobMatchDetailsFlag = false;
        setTimeout(() => {
            this.setOutreachQuestionsForFeedback(this.activeOutreachFeedbackQuestionsList);
        }, 300);
    }

    saveOutreachFeedback(successCallback) {
        let listofCompanyQuestions;
        let listofClientQuestions = [];
        let companyCompleted = true;
        let clientAllCompleted = true;
        let companyOverallCompleted = true;

        if (this.recruiterqns != null) {
            const companyId = this.recruiterqns.candidateOutreachJobMatchInfo ? this.recruiterqns.candidateOutreachJobMatchInfo.jobMatches[0].companyId : this.companyId;
            this.recruiterqns.companyQuestionsResults[companyId].forEach((val, key) => {
                val.questionareDateTime = this.dateTimeUtilityService.getCurrentTimeStampInAPIFormat();
                val.questionType = 'O';
                val.lastModifiedBy = this.candidateId;
                val.participantId = this.candidateId;
                val.userId = this.candidateId;
                if (val.question != 'Overall Comment') {
                    if (val.rating == '0' && this.isEmpty(val.recruiterComment)) {
                        companyCompleted = false;
                    }
                } else if (val.question == 'Overall Comment') {
                    if (val.rating == '0' && this.isEmpty(val.recruiterComment)) {
                        companyOverallCompleted = false;
                    }
                }
            });
            if (!this.disableFeedbackQuestions) {
                listofCompanyQuestions = this.recruiterqns.companyQuestionsResults[companyId];
            } else {
                listofCompanyQuestions = this.recruiterqns.companyQuestionsResults[companyId].filter(
                    val => val.question && val.question.match(/^Overall/)
                );
            }

            Object.keys(this.recruiterqns.clientQuestionsResults).forEach((clientKey) => {
                const clientVal = this.recruiterqns.clientQuestionsResults[clientKey];
                if (this.activeOutreachFeedbackQuestionsList.includes(clientKey)) {
                    clientVal.forEach((val, key) => {
                        val.questionareDateTime = this.dateTimeUtilityService.getCurrentTimeStampInAPIFormat();
                        val.questionType = 'O';
                        val.lastModifiedBy = this.candidateId;
                        val.participantId = this.candidateId;
                        val.userId = this.candidateId;
                        if (val.rating == '0' && this.isEmpty(val.recruiterComment)) {
                            clientAllCompleted = false;
                        }
                    });
                    if (listofClientQuestions) {
                        listofClientQuestions = listofClientQuestions.concat(clientVal);
                    } else {
                        listofClientQuestions = clientVal;
                    }
                }
            });
        }

        if (this.activeOutreachFeedbackQuestionsList.length > 0 && (!companyCompleted || !clientAllCompleted || !companyOverallCompleted)) {
            if (successCallback) {
                successCallback({ isValid: false, listOfClientQuestions: listofClientQuestions, listOfCompanyQuestions: listofCompanyQuestions });
            }
        } else {
            if (successCallback) {
                successCallback({ isValid: true, listOfClientQuestions: listofClientQuestions, listOfCompanyQuestions: listofCompanyQuestions });
            }
        }
    }

    getAllPreferredJobTypes() {
        this.jobService.getAllJobTypes((data) => {
            this.jobTypeList = data;
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    getSalaryDurationOptions() {
        this.jobService.getSalaryDurationOptions((data) => {
            this.salaryDurationOptions = data;
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

}
